var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications"},_vm._l((_vm.notifications),function(alert,index){return _c('div',{key:index},[_c('NotificationsAlert',{attrs:{"alert":alert}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }